import BigNumber from 'bignumber.js'
import Web3 from 'web3'
import { HttpProviderOptions } from 'web3-core-helpers'
import { provider as ProviderType } from 'web3-core'
import { AbiItem } from 'web3-utils'
import { ethers } from 'ethers'
import getRpcUrl from 'utils/getRpcUrl'
import abiErc20 from 'config/abi/erc20.json'
import multiCallAbi from 'config/abi/Multicall.json'
import {multicallWithContract} from './multicall'
import { CHAINS } from './wallet'

declare const window: any

export const RpcUrls = {
    56: "https://rpc.ankr.com/bsc/3e2f2ba3bd16222a04dd42e1662458647bcdadefaec664149d20438292db76c8",
    10000 : getRpcUrl()
  }

const CHAINWEB3 = {

};

export const getWeb3 = (chainId) => {
    if (chainId === -1) return new Web3(window.ethereum);
    const chain = CHAINS[chainId];
    if (chain) {
        if (!CHAINWEB3[chainId]) {
            const provider = new Web3.providers.HttpProvider(RpcUrls[chainId], { timeout: 10000 } as HttpProviderOptions)
            const newWeb3 = new Web3(provider);
            CHAINWEB3[chainId] = newWeb3;
        }
        
        return CHAINWEB3[chainId];
    }

    return undefined;
}

export const Config = {
    tokens: {
        "BTC": {
            name: "Bitcoin",
            decimals: 18,
            56: "0x7130d2A12B9BCbFAe4f2634d864A1Ee1Ce3Ead9c",
            10000: "0xbbeF77270d6425E113e1E37f008cf141a9FC215A"
        },
        "ETH": {
            name: "Ether",
            decimals: 18,
            56: "0x2170Ed0880ac9A755fd29B2688956BD959F933F8",
            10000: "0xbb10B6D11db70f33417b08e0B87042275C933Bb9"
        },
        "BCH": {
            name: "Bitcoin Cash",
            decimals: 18,
            56: "0x8fF795a6F4D97E7887C79beA79aba5cc76444aDf",
            10000: "0xbb7b43eb950C0fDBb645D7d05a27395Ed8D944fA"
        },
        "BNB": {
            name: "Binance Coin",
            decimals: 18,
            56: "0x0000000000000000000000000000000000000001",
            10000: "0xbb7eED96c099546049179c6ACB4498926C437158",
            estimatedGasForNativeCoin: 0.01
        },
        "EBEN": {
            name: "Green Ben",
            decimals: 18,
            56: "0xbb036ccDe5feE48f011B9916646f3a341d7D490A",
            10000: "0x77CB87b57F54667978Eb1B199b28a0db8C8E1c0B"
        },
        "USDT": {
            name: "Tether USD",
            decimals: 18,
            56: "0x55d398326f99059fF775485246999027B3197955",
            10000: "0xbbb3700F33fCb64437Dc28A7Beb6b21f5cC76FB9"
        },
        "USDC": {
            name: "USD Coin",
            decimals: 18,
            56: "0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d",
            10000: "0xbb2A35cc3e3dDb679fe30A82051633bC822e4191"
        },
        "USDP": {
            name: "Pax Dollar",
            decimals: 18,
            56: "0xb3c11196A4f3b1da7c23d9FB0A3dDE9c6340934F",
            10000: "0xbbEDC71c1e982c5416dEcc221B5c9DcA8ff49E94"
        },
        "BUSD": {
            name: "Binance USD",
            decimals: 18,
            56: "0xe9e7CEA3DedcA5984780Bafc599bD69ADd087D56",
            10000: "0xbb1Fcb08961d7fc7ab58dC608A0448aa30E66269"
        },
        "TUSD": {
            name: "TrueUSD",
            decimals: 18,
            56: "0x40af3827F39D0EAcBF4A168f8D4ee67c121D11c9",
            10000: "0xbb8D72Bf8601f86A65d852bD2347119952C71d0e"
        }
    },
    chains: {
        56: {
            "name": "BNB Smart Chain",
            "shortName": "BSC",
            "symbol": "BSC",
            "bridge": "0xab24515e162593D6aa825abF4d5816e5025818B9",
            "multicall": "0x1ee38d535d541c55c9dae27b12edf090c608e6fb"
        },
        10000: {
            "name": "smartBCH",
            "shortName": "smartBCH",
            "symbol": "sBCH",
            "bridge": "0xe35A42B384E7A2b26a6B2CE96BD1657572b601Ea",
            "multicall": "0x1b38EBAd553f218e2962Cb1C0539Abb5d6A37774"
        }
    }
}

// This is a temporary measure to mitigate the issue that the Ankr node retures inconsistent gas price on BSC
const getGasPriceObj = (contract) => {
    if (Number(contract.currentProvider.networkVersion) === 56) {
        return {gasPrice:3000000000};
    }
    return {};
}

export const approve = (contract, spender, account) => {
    return contract.methods
      .approve(spender, ethers.constants.MaxUint256)
      .send({...getGasPriceObj(contract), from: account });
}

export const getTokenAddress = (chainId, symbol) => {
    const info = Config.tokens[symbol];
    return info && info[chainId];
}

export const getTokenDecimals = (symbol) => {
    const info = Config.tokens[symbol];
    return info?.decimals;
}

export const getBridgeAddress = (chainId) => {
    const info = Config.chains[chainId];
    return info?.bridge;
}

export const getTokenList = (chainId1, chainId2) => {
    return Object.keys(Config.tokens).filter(symbol=> {
        const info = Config.tokens[symbol];
        return info[chainId1] && info[chainId2];
    });
}

export const depositTokens = (contract, token, value, toChainId, account) => {
    const o: any = { ...getGasPriceObj(contract), from: account };
    if (new BigNumber(token).isLessThan(32)) o.value = value;
    return contract.methods.depositTokens(token, value, toChainId).send(o);
}

export const claim = (contract, token, txId, to, value, fromChainId, sig, account) => {
    return contract.methods.claim(token, txId, to, value, fromChainId, sig).send({...getGasPriceObj(contract), from: account });
}

export const getAuth = async(fromChainId, txId) => {
    const response = await fetch(`https://bridgeapi.benswap.cash/auth?chain=${fromChainId}&tx=${txId}`);
    const data = await response.json();
    return data;
}

export const getTokenBalances = async(chainId, account) => {
    const chainInfo = Config.chains[chainId];
    const web3 = getWeb3(chainId);
    const result:any = {};
    if (chainInfo && web3 && account) {
        const bridgeAddress = getBridgeAddress(chainId);
        const tokensArray = Object.keys(Config.tokens);
        const ta2 = [];
        const calls = [];
        for(let l=0; l<tokensArray.length; l++) {
            const tokenAddress = getTokenAddress(chainId, tokensArray[l]);
            if (!new BigNumber(tokenAddress).isLessThan(32)) {
                calls.push({
                    address: tokenAddress,
                    name: 'balanceOf',
                    params: [account],
                },{
                    address: tokenAddress,
                    name: 'allowance',
                    params: [account, bridgeAddress],
                });
                ta2.push(tokensArray[l]);
            } else {
                // Native coin: TBD
                const b = await web3.eth.getBalance(account);
                const bb = new BigNumber(b).div(new BigNumber(10).pow(getTokenDecimals(tokensArray[l])||0));
                const eg = Config.tokens[tokensArray[l]].estimatedGasForNativeCoin;
                result[tokensArray[l]] = {
                    balance: bb,
                    allowance: new BigNumber(1e99),
                    allowance_r: new BigNumber(1e99),
                    maxBalance: bb.isGreaterThanOrEqualTo(eg) ? bb.minus(eg):new BigNumber(0)
                }
            }
        }

        const multi = new web3.eth.Contract((multiCallAbi as unknown) as AbiItem, chainInfo.multicall);
        const res = await multicallWithContract(multi, abiErc20, calls);
        for(let m=0; m<ta2.length; m++) {
            result[ta2[m]] = {
                balance: new BigNumber(res[m*2][0]._hex).div(new BigNumber(10).pow(getTokenDecimals(ta2[m])||0)),
                allowance: new BigNumber(res[m*2+1][0]._hex),
                allowance_r: new BigNumber(res[m*2+1][0]._hex).div(new BigNumber(10).pow(getTokenDecimals(ta2[m])||0))
            }
        }
    }

    return result;
}

export const getTokenBalancesOfAllChains = async(account) => {
    const result:any = {};

    if (account) {
        const tasks = [];
        Object.keys(Config.chains).forEach(c=> {
            tasks.push(getTokenBalances(c, account).then(r=> {
                result[c] = r;
            }));
        });
        await Promise.all(tasks);
    }

    return result;
}
